import { gql } from '@apollo/client'

export const Query = gql`
  query EditCustomFieldValue($companyId: ID!, $filters: CustomFieldValueFilters) {
    customFieldValues(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        customField {
          id
          name
          enabled
        }
        resourceId
        resourceType
        value
      }
    }
  }
`
